// https://stackoverflow.com/a/35759874 Using `!isNan(Number(str))` or `!isNaN(str)`
// fails on empty string, so we use a more complicated method. Notice that this method
// will not accept "  5 " as numeric but that is fine.
export default (str: string): boolean => {
    return !isNaN(Number(str)) && !isNaN(parseFloat(str));
};
